// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorGroupSupervisoryStatus } from './escalator-group-supervisory-status';


export class EscalatorGroupSupervisoryStatusMessage implements flatbuffers.IUnpackableObject<EscalatorGroupSupervisoryStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorGroupSupervisoryStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorGroupSupervisoryStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorGroupSupervisoryStatusMessage):EscalatorGroupSupervisoryStatusMessage {
  return (obj || new EscalatorGroupSupervisoryStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorGroupSupervisoryStatusMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorGroupSupervisoryStatusMessage):EscalatorGroupSupervisoryStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorGroupSupervisoryStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EscalatorGroupSupervisoryStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EscalatorGroupSupervisoryStatus.UpPeak;
}

static startEscalatorGroupSupervisoryStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EscalatorGroupSupervisoryStatus) {
  builder.addFieldInt16(0, message, EscalatorGroupSupervisoryStatus.UpPeak);
}

static endEscalatorGroupSupervisoryStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEscalatorGroupSupervisoryStatusMessage(builder:flatbuffers.Builder, message:EscalatorGroupSupervisoryStatus):flatbuffers.Offset {
  EscalatorGroupSupervisoryStatusMessage.startEscalatorGroupSupervisoryStatusMessage(builder);
  EscalatorGroupSupervisoryStatusMessage.addMessage(builder, message);
  return EscalatorGroupSupervisoryStatusMessage.endEscalatorGroupSupervisoryStatusMessage(builder);
}

unpack(): EscalatorGroupSupervisoryStatusMessageT {
  return new EscalatorGroupSupervisoryStatusMessageT(
    this.message()
  );
}


unpackTo(_o: EscalatorGroupSupervisoryStatusMessageT): void {
  _o.message = this.message();
}
}

export class EscalatorGroupSupervisoryStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EscalatorGroupSupervisoryStatus = EscalatorGroupSupervisoryStatus.UpPeak
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EscalatorGroupSupervisoryStatusMessage.createEscalatorGroupSupervisoryStatusMessage(builder,
    this.message
  );
}
}
